<div class="modal-header">
  <h1 class="modal-title" id="modal-dnp-title" ngbAutofocus tabindex="-1">Did Not Purchase</h1>
  <button type="button" class="close" aria-label="Close" (click)="onCancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="modalForm" (ngSubmit)="onSubmit()">
  <div class="modal-body">
    <p>
      By checking off the box below, the primary dealer is certifying that the business did not purchase any marine life
      for resale purposes from licensed fishers during that Weekly Report Period.
    </p> <br>
    <div class="btn-group btn-group-vertical customRadio" data-toggle="buttons">
      <label class="btn active">
        <input type="checkbox" formControlName="didNotPurchase" required>
        <i class="far fa-square"></i><i class="far fa-check-square"></i>
        <span> I did not purchase during the period of {{period?.start | date:'mediumDate'}}
          to {{period?.lastDay() | date:'mediumDate'}}</span>
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" [disabled]="!modalForm.valid" class="btn btn-primary btn">
      <i class="fas fa-check"> </i> Submit
    </button>
    <button type="button" class="btn btn-secondary btn" (click)="onCancel()">
      <i class="fas fa-times"> </i> Cancel
    </button>
  </div>
</form>
